export const PolicyErrorCodesEnum = Object.freeze({
  CREATE_POLICY_ERROR: 'createPolicyError',
  SUBMIT_POLICY_ERROR: 'submitPolicyError',
  SUBMIT_POLICY_IN_PROCESS_ERROR: 'submitPolicyInProcess',
  TIMEOUT_ERROR: 'ECONNABORTED',
  TIMEOUT_ERROR_CRM: '0x80040224',

});

export default PolicyErrorCodesEnum;
